package club.srams.website.pages

import androidx.compose.runtime.Composable
import club.srams.website.HeadlineTextStyle
import club.srams.website.SubheadlineTextStyle
import club.srams.website.components.layouts.PageLayoutData
import club.srams.website.components.widgets.Carousel
import club.srams.website.toSitePalette
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@InitRoute
fun initFieldTripsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Field Trips"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun FieldTripsPage() {
    Row(HeroContainerStyle.toModifier()) {
        Box {
            val sitePalette = ColorMode.current.toSitePalette()

            Column(Modifier.gap(2.cssRem)) {
                Div(HeadlineTextStyle.toAttrs()) {
                    SpanText(
                        "Field Trips", Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }

    }

    Row {
        Column {
            FieldTripSchedulePage()  // ← generated from FieldTripSchedule.md
        }
    }

    Row(HeroContainerStyle.toModifier()) {
        Box {
            val sitePalette = ColorMode.current.toSitePalette()

            Column(Modifier.gap(2.cssRem)) {
                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText(
                        "2025.10.14 Dosewallips State Park", Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }

        Div(
        ) {
            Column {

                Carousel(
                    `2025_10_14_dosewallips_state_park`
                    , modifier = Modifier.width(500.px).height(400.px)
                )
            }
        }
    }

    Row(HeroContainerStyle.toModifier()) {
        Box {
            val sitePalette = ColorMode.current.toSitePalette()

            Column(Modifier.gap(2.cssRem)) {
                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText(
                        "2025.11.08 North Beach County Park", Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }

        Div(
        ) {
            Column {

                Carousel(
                    `2025_11_08_north_beach_county_park`
                    , modifier = Modifier.width(500.px).height(400.px)
                )
            }
        }
    }
}

private val `2025_10_14_dosewallips_state_park` = listOf<Pair<String,String>>(
    Pair(
        "/images/field_trips/2025/10_14_dosewallips_state_park/image_1.jpg"
        , "North Beach County Park"
    )
//    , Pair(
//        "/images/field_trips/2025/10_14_dosewallips_state_park/image_2.jpg"
//        , "North Beach County Park"
//    )
//    , Pair(
//        "/images/field_trips/2025/10_14_dosewallips_state_park/image_3.jpg"
//        , "North Beach County Park"
//    )
//    , Pair(
//        "/images/field_trips/2025/10_14_dosewallips_state_park/image_4.jpg"
//        , "North Beach County Park"
//    )
//    , Pair(
//        "/images/field_trips/2025/10_14_dosewallips_state_park/image_5.jpg"
//        , "North Beach County Park"
//    )
//    , Pair(
//        "/images/field_trips/2025/11_08_north_beach_county_park/image_6.jpg"
//        , "North Beach County Park"
//    )
)
private val `2025_11_08_north_beach_county_park` = listOf<Pair<String,String>>(
    Pair(
        "/images/field_trips/2025/11_08_north_beach_county_park/image_1.jpg"
        , "North Beach County Park"
    )
    , Pair(
        "/images/field_trips/2025/11_08_north_beach_county_park/image_2.jpg"
        , "North Beach County Park"
    )
    , Pair(
        "/images/field_trips/2025/11_08_north_beach_county_park/image_3.jpg"
        , "North Beach County Park"
    )
    , Pair(
        "/images/field_trips/2025/11_08_north_beach_county_park/image_4.jpg"
        , "North Beach County Park"
    )
    , Pair(
        "/images/field_trips/2025/11_08_north_beach_county_park/image_5.jpg"
        , "North Beach County Park"
    )
    , Pair(
        "/images/field_trips/2025/11_08_north_beach_county_park/image_6.jpg"
        , "North Beach County Park"
    )
)